module.exports = __webpack_public_path__ + "media/images/country_flags/ki-66247004ed662c014a5acb5dc5dde6a2.png";